import { Fragment, useEffect } from 'react';
import { EventConstants } from '../constants/events';
import {
  useDisplayContainer,
  DisplayContainer,
  useEventManager,
} from '../hooks';

const ContainerLayout = () => {
  const [, handleShowToast, handleHideToast, ToastComponent] =
    useDisplayContainer({
      type: DisplayContainer.TOAST,
    });
  const [modalVisibility, handleShowModal, handleHideModal, ModalComponent] =
    useDisplayContainer({
      type: DisplayContainer.MODAL,
    });
  const [
    ,
    handleShowCircularProgress,
    handleHideCircularProgress,
    CircularProgressComponent,
  ] = useDisplayContainer({
    type: DisplayContainer.CIRCULAR_PROGRESS,
  });
  const [, handleShowSideDrawer, handleHideSideDrawer, SideDrawerComponent] =
    useDisplayContainer({
      type: DisplayContainer.SIDE_DRAWER,
    });

  useEventManager([
    { event: EventConstants.SHOW_TOAST, action: handleShowToast },
    { event: EventConstants.SHOW_MODAL, action: handleShowModal },
    {
      event: EventConstants.SHOW_CIRCULAR_PROGRESS,
      action: handleShowCircularProgress,
    },
    { event: EventConstants.SHOW_SIDEDRAWER, action: handleShowSideDrawer },
    // { event: EventConstants.SHOW_GLOBAL_ACTIONS_POPOVER, action: handleShowPopover },
    { event: EventConstants.HIDE_TOAST, action: handleHideToast },
    { event: EventConstants.HIDE_MODAL, action: handleHideModal },
    {
      event: EventConstants.HIDE_CIRCULAR_PROGRESS,
      action: handleHideCircularProgress,
    },
    {
      event: EventConstants.HIDE_CIRCULAR_PROGRESS,
      action: handleHideCircularProgress,
    },
    { event: EventConstants.HIDE_SIDEDRAWER, action: handleHideSideDrawer },
    // { event: EventConstants.HIDE_GLOBAL_ACTIONS_POPOVER, action: handleHidePopover },
  ]);

  useEffect(() => {
    const body = document.body;
    body.style.overscrollBehaviorX = modalVisibility ? 'none' : 'auto';

    return () => {
      body.style.overscrollBehaviorX = 'auto';
    };
  }, [modalVisibility]);

  return (
    <Fragment>
      {ModalComponent()}
      {ToastComponent()}
      {CircularProgressComponent()}
      {SideDrawerComponent()}
    </Fragment>
  );
};

export default ContainerLayout;
